import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { NAV, SITE } from '../data/site';
import { LogoMark } from './Logo';
import BookLink from './BookLink';

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const toggleRef = useRef<HTMLButtonElement>(null);

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { setOpen(false); toggleRef.current?.focus(); }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <header className="header">
      <div className="container header__inner">
        <Link to="/" className="brand" aria-label={`${SITE.name} home`}>
          <LogoMark className="brand__mark" priority />
          <span className="brand__text">Skin <em>by</em> Lizzy</span>
        </Link>

        <nav id="site-nav" className={`nav ${open ? 'nav--open' : ''}`} aria-label="Main">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({ isActive }) => `nav__link ${isActive ? 'is-active' : ''}`}>
              {n.label}
            </NavLink>
          ))}
          <BookLink className="btn btn--primary nav__cta" />
        </nav>

        <button
          ref={toggleRef}
          className="menu-toggle"
          aria-controls="site-nav"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen(o => !o)}
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
};

export default Header;
